import { render } from "./App.vue?vue&type=template&id=049866d8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "animate.css/animate.min.css?vue&type=style&index=0&lang=css"
import "./App.vue?vue&type=style&index=1&id=049866d8&lang=css"

import exportComponent from "/Users/matalem/system/radioaconcagua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__